import { AnyAction } from 'redux'

import { LOAD_ENUMS_SUCCESS } from './types'

interface State {
  readonly [key: string]: string[]
}

const defaultState: State = {}

function enumsReducer(state: State = defaultState, action: AnyAction): State {
  switch (action.type) {
    case LOAD_ENUMS_SUCCESS:
      return action.payload.data.Data
    default:
      return state
  }
}

export default enumsReducer
